import { Modal } from "newui/components/ui/Modal";
import type { ComplianceQuestion } from "newui/features/Settings/types/ComplianceQuestion.type";

interface ComplianceDeleteModalProps {
	pendingDelete: ComplianceQuestion | null;
	isDeleting: boolean;
	onConfirm: () => void;
	onCancel: () => void;
}

export const ComplianceDeleteModal = ({
	pendingDelete,
	isDeleting,
	onConfirm,
	onCancel,
}: ComplianceDeleteModalProps) => {
	return (
		<Modal
			isOpen={pendingDelete !== null}
			modalType="alert"
			iconType="warning"
			title="Delete compliance question?"
			primaryButton={{
				text: "Delete",
				btntype: "danger",
				isLoading: isDeleting,
				onClick: onConfirm,
			}}
			secondaryButton={{
				text: "Cancel",
				disabled: isDeleting,
				onClick: onCancel,
			}}
			onClose={() => {
				if (!isDeleting) {
					onCancel();
				}
			}}
		>
			<div
				className="space-y-3 text-sm text-gray-700"
				data-testid="compliance-question-delete-modal"
			>
				<p>
					Are you sure you want to delete this compliance question? This
					can&apos;t be undone.
				</p>
				{pendingDelete && (
					<p
						className="rounded-md bg-gray-50 px-3 py-2 font-medium text-gray-900"
						data-testid="compliance-question-delete-target"
					>
						{pendingDelete.question}
					</p>
				)}
			</div>
		</Modal>
	);
};
